import React, { useEffect, useState } from 'react';
import { Card, CardTitle, CardBody, Button, Table } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import useVendorBranch from '../../utils/useVendorBranch';
import { toast } from 'react-toastify';

const NotificationList = () => {
  const { user } = useSelector((state) => state.authState);
  const navigate = useNavigate();

  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const [errorMessage, setErrorMessage] = useState({});
  const [notificationList, setNotificationList] = useState([]);

  // ✅ Same like WeekendList
  const [selectionData, setSelectionData] = useState({
    vendor_id: '',
    branch_id: '',
  });

  const onHandleAdd = () => navigate('/save-notification');

  const onHandleEdit = (id) => {
    const selected = notificationList.find(
      (x) => (x.notification_id || x.id) === id,
    );
    navigate('/save-notification', { state: { ...(selected || {}) } });
  };

  const GetNotificationList = async () => {
    try {
      const vendorId = selectionData.vendor_id || '';
      const branchId = selectionData.branch_id || '';

      // If your API has extra params, keep empty defaults
      const res = await apiService.get(
        `api/SendNotification/GetAllNotification?search=&vendorId=${vendorId}&branchId=${branchId}&sentYn=&profile=&type=`,
      );

      if (res?.status === true) {
        setNotificationList(res.data || res.Data || []);
      } else {
        toast.error(res?.message || res?.Message || 'Failed');
      }
    } catch (e) {
      console.error(e);
      toast.error('Something went wrong');
    }
  };

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad) GetNotificationList();
  }, [selectionData.vendor_id, selectionData.branch_id]);

  const fmtDate = (d) => {
    if (!d) return '';
    const dt = new Date(d);
    if (Number.isNaN(dt.getTime())) return '';
    return dt.toLocaleDateString();
  };

  const fmtTime = (d) => {
    if (!d) return '';
    const dt = new Date(d);
    if (Number.isNaN(dt.getTime())) {
      // if backend sends "14:30:00" etc
      if (typeof d === 'string' && d.includes(':')) return d.substring(0, 5);
      return '';
    }
    const hh = String(dt.getHours()).padStart(2, '0');
    const mm = String(dt.getMinutes()).padStart(2, '0');
    return `${hh}:${mm}`;
  };

  return (
    <>
      <div className='text-right mb-2'>
        <Button color='primary' onClick={onHandleAdd}>
          <i className='bi bi-plus-circle' /> Add Notification
        </Button>
      </div>

      <VendorBranchSelector
        user={user}
        selectionData={selectionData}
        setSelectionData={setSelectionData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='p-3 mb-0'>
          <i className='bi bi-bell mr-2' /> Notification List
        </CardTitle>

        <CardBody>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Edit</th>
                <th>Title</th>
                <th>Type</th>
                <th>Send To</th>
                <th>Schedule Date</th>
                <th>Schedule Time</th>
              </tr>
            </thead>

            <tbody>
              {notificationList.length > 0 ? (
                notificationList.map((x, i) => (
                  <tr key={x.notification_id || x.id || i}>
                    <td>{i + 1}</td>
                    <td>
                      <i
                        className='bi bi-pencil text-primary'
                        style={{ cursor: 'pointer' }}
                        onClick={() => onHandleEdit(x.notification_id || x.id)}
                      />
                    </td>
                    <td>{x.title}</td>
                    <td>{x.notification_type}</td>
                    <td>{x.send_to_profile}</td>
                    <td>{fmtDate(x.schedule_for)}</td>
                    <td>{fmtTime(x.scheduled_time)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan='8' className='text-center'>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </>
  );
};

export default NotificationList;
